import * as React from 'react';
import { Box, IBoxProps } from '@lce/slice';
import { map as _map } from 'lodash';

import * as Styled from './ImageBanner.style';
import { Image } from '../../lib/banners/types'

export interface IImageBannerProps extends IBoxProps {
  images: Image[];
  link?: {
    url: string;
    text: string;
  };
  fullWidth?: boolean;
  backgroundColor?: string;
}

export const ImageBanner: React.FC<IImageBannerProps> = ({ backgroundColor, images, link, fullWidth, ...props }) => {
  
  let desktopImage = images[0];
  let mobileImage = images[1];
  let includesMobile = false;

  _map(images, (image: Image) => {
    if (image.type.toLowerCase().includes('desktop')) {
      desktopImage = image;
    } else if (image.type.toLowerCase().includes('mobile')) {
      mobileImage = image;
      includesMobile = true;
    }
  });

  const params = new URLSearchParams(link?.url.split('?')[1]);
  const promo = params.get('promo');
  const promoId = link?.url && link.url.includes('/app/') && link.url.includes('promo=') ? `click-home-${promo}` : '';

  return (
    <Styled.ImageBanner as="section" backgroundColor={backgroundColor} {...props}>
      <Box>
        <Styled.Link href={link?.url} id={promoId} title={link?.text}>
          <Styled.DesktopImage
            alt={desktopImage.alt}
            data-testid="desktopimage"
            fullWidth={fullWidth}
            m="0 auto"
            src={desktopImage.url}
            width="100%"
          />
          {includesMobile && (
            <Styled.MobileImage alt={mobileImage.alt} data-testid="mobileimage" src={mobileImage.url} width="100%" />
          )}
        </Styled.Link>
      </Box>
    </Styled.ImageBanner>
  );
};
